module.exports = __webpack_public_path__ + "img/radio-selected.03cbe9a4.svg";